/*
 *
 * MMPay actions
 *
 */

import * as cn from './constants';

export const getScores = payload => ({
  type: cn.SCORE_INIT,
  payload,
});

export const getScoresSuccess = payload => ({
  type: cn.SCORE_SUCCESS,
  payload,
});

export const getScoresError = error => ({
  type: cn.SCORE_ERROR,
  error,
});

export const getDailySummary = payload => ({
  type: cn.DAILY_SUMMARY_INIT,
  payload,
});

export const getDailySummarySuccess = payload => ({
  type: cn.DAILY_SUMMARY_SUCCESS,
  payload,
});

export const getDailySummaryError = error => ({
  type: cn.DAILY_SUMMARY_ERROR,
  error,
});

export const getTransactions = payload => ({
  type: cn.TRANSACTIONS_INIT,
  payload,
});

export const getTransactionsSuccess = payload => ({
  type: cn.TRANSACTIONS_SUCCESS,
  payload,
});

export const getTransactionsError = error => ({
  type: cn.TRANSACTIONS_ERROR,
  error,
});

export const setMmpayRestaurantStartTime = payload => ({
  type: cn.SET_MMPAY_RESTAURANT_START_TIME,
  payload,
});
